export default function ActivityDetails() {
    return (<>
        <p>Activity Details Page</p>
    </>);
}